<script>
  import { Layer } from 'svelte-canvas';
  import { onMount } from 'svelte';
  import { foregroundPosition, selectedBackground, gradientEffect, gradientDirection } from '../stores.js';
  import { backgrounds } from '../data/backgrounds.js';

  export let svelteCanvas;

  const bgImage = new Image();
  bgImage.onload = drawCanvas;

  function drawCanvas() {
    // console.log(bgImage.width, bgImage.height);
    svelteCanvas.redraw();
  }

  selectedBackground.subscribe(background => {
    bgImage.src = backgrounds[background].filePath;
  });

  // Render function
  // ---
  $: render = ({ context, width, height }) => {

    // Tottenham blue, from the svg logo
    const blue = 'hsl(227, 64%, 21%)';

    // blue background
    context.fillStyle = blue;
    context.fillRect(0, 0, width, height);


    /**
     *  Draw background image
     * ---
     * The source image is large enough for a variety of screen sizes, but it
     * has to be scaled to match the wallpaper dimensions while minimizing
     * the warping of the source image.
     *
     * Provide an option to choose your "Fill" style?
     *    Fit, Stretch, Center
     *    Zoom/Fill, Full Image
     *
     */
    const scaledWidth = Math.ceil(bgImage.width * (height / bgImage.height));
    const scaledHeight = Math.ceil(bgImage.height * (width / bgImage.width));
    let sx = 0;
    let sy = 0;

    // fill the whole wallpaper area
    // ---
    // if the scaled width doesn't fit the screen, is less than the canvas width,
    // then draw the image using the canvas width and the scaled Height instead.
    // change sy variable so image is centered in canvas
    if (scaledWidth < width) {
      sy = (scaledHeight - height) / 2;
      sy *= -1;
      context.drawImage(bgImage, sx, sy, width, scaledHeight);
    } else {
      // otherwise, the scaled width is fine, so update sx to center image horizontally
      sx = (scaledWidth - width) / 2;
      sx *= -1;
      context.drawImage(bgImage, sx, sy, scaledWidth, height);
    }


    // gradient effects
    // ===
    // if 'None', do nothing
    if ($gradientEffect === 2) return;

    // subtle
    if ($gradientEffect === 1) {
      const size = width / 3;
      let subtleGradientEffect;
      // foregroundPosition will be a number, 0–3
      //    0 - bottom-left
      //    1 - bottom-right
      //    2 - top-right
      //    3 - top-left
      if ($foregroundPosition === 0) {
        // subtle, bottom-left
        subtleGradientEffect = context.createLinearGradient(0, height, size, 0);
      } else if ($foregroundPosition === 1) {
        // subtle, bottom-right
        subtleGradientEffect = context.createLinearGradient(width, height, size * 2, 0);
      } else if ($foregroundPosition === 2) {
        // subtle, top-right
        subtleGradientEffect = context.createLinearGradient(width, 0, size * 2, height)
      } else if ($foregroundPosition === 3) {
        // subtle, top-left
        subtleGradientEffect = context.createLinearGradient(0, 0, size, height);
      }

      // add the color
      subtleGradientEffect.addColorStop(0, blue);
      subtleGradientEffect.addColorStop(0.5, 'transparent');

      context.globalCompositeOperation = 'color';
      context.fillStyle = subtleGradientEffect;
      context.fillRect(0, 0, width, height);
      context.globalCompositeOperation = 'source-over';

      context.globalAlpha = 0.8;
      context.fillRect(0, 0, width, height);

      context.globalAlpha = 1;
      context.globalCompositeOperation = 'multiply';
      context.fillRect(0, 0, width, height);
    }

    // overlay
    if ($gradientEffect === 0) {
      let overlayGradient;

      if ($foregroundPosition === 0 || $foregroundPosition === 1) {
        // draw top-bottom gradient
        overlayGradient = context.createLinearGradient(width / 2, 0, width / 2, height);
      } else if ($foregroundPosition === 2) {
        // left-right
        overlayGradient = context.createLinearGradient(0, height / 2, width, height / 2);
      } else if ($foregroundPosition === 3) {
        // right-left
        overlayGradient = context.createLinearGradient(width, height / 2, 0, height / 2);
      }


      overlayGradient.addColorStop(0, 'transparent');
      overlayGradient.addColorStop(0.34, 'hsla(227, 64%, 21%, 0.5)');
      overlayGradient.addColorStop(1, blue);

      // color layer
      context.globalCompositeOperation = 'color';
      context.fillStyle = blue;
      context.fillRect(0, 0, width, height);

      // reset composition
      context.globalCompositeOperation = 'source-over';

      // normal blue layer at 80% opacity
      context.globalAlpha = 0.8;
      context.fillStyle = blue;
      context.fillRect(0, 0, width, height);

      // reset alpha
      context.globalAlpha = 1;
      context.fillStyle = overlayGradient;
      context.globalCompositeOperation = 'multiply';
      context.fillRect(0, 0, width, height);
    }

    // reset composition
    context.globalCompositeOperation = 'source-over';
  };
</script>

<Layer {render}/>
